<!-- 优惠券 -->
<template>
    <div class="MMyCoupon" v-if="init">
        <van-tabs v-model="active" @change="tabChange">
            <van-tab :title="`未使用（${summary.unusecount}）`">
                <Pull :pull="pull1" :page="page1" @getList="getMyCoupongetinfo">
                    <NoData v-if="!list1.length"></NoData>
                    <div class="list1" v-else>
                        <div class="item" v-for="(item, index) in list1" :key="index">
                            <div class="left">
                                <div class="value_box" v-if="item.voucherdistype === 1">
                                    <span class="unit">￥</span>
                                    <span class="value">{{item.faceprice}}</span>
                                    <span class="minordermoney">
                                        <span v-if="item.userule === 0">满{{item.minordermoney}}元可用</span>
                                        <span v-if="item.userule === 1">无门槛</span>
                                    </span>
                                </div>
                                <div class="value_box" v-if="item.voucherdistype === 2">
                                    <span class="value">{{item.voucherdisrate}}</span>
                                    <span class="unit">折</span>
                                    <span class="minordermoney">
                                        <span v-if="item.userule === 0">满{{item.minordermoney}}元可用</span>
                                        <span v-if="item.userule === 1">无门槛</span>
                                    </span>
                                </div>
                                <div class="datetime">{{item.datetime}}</div>
                                <div class="usescopetype">{{item.usescopetype === 2 ? '指定商品可用' : '平台部分商品可用'}}</div>
                            </div>
                            <div class="right">
                                <van-button @click="nowUse(item)">立即使用</van-button>
                            </div>
                        </div>
                    </div>
                </Pull>
            </van-tab>
            <van-tab :title="`已使用（${summary.usecount}）`">
                <Pull :pull="pull2" :page="page2" @getList="getMyCoupongetinfo">
                    <NoData v-if="!list2.length"></NoData>
                    <div class="list1" v-else>
                        <div class="item" v-for="(item, index) in list2" :key="index">
                            <div class="left">
                                <div class="value_box" v-if="item.voucherdistype === 1">
                                    <span class="unit">￥</span>
                                    <span class="value">{{item.faceprice}}</span>
                                    <span class="minordermoney">
                                        <span v-if="item.userule === 0">满{{item.minordermoney}}元可用</span>
                                        <span v-if="item.userule === 1">无门槛</span>
                                    </span>
                                </div>
                                <div class="value_box" v-if="item.voucherdistype === 2">
                                    <span class="value">{{item.voucherdisrate}}</span>
                                    <span class="unit">折</span>
                                    <span class="minordermoney">
                                        <span v-if="item.userule === 0">满{{item.minordermoney}}元可用</span>
                                        <span v-if="item.userule === 1">无门槛</span>
                                    </span>
                                </div>
                                <div class="datetime">{{item.datetime}}</div>
                                <div class="usescopetype">{{item.usescopetype === 2 ? '指定商品可用' : '平台部分商品可用'}}</div>
                            </div>
                            <div class="right">
                                <!-- <van-button>立即使用</van-button> -->
                            </div>
                            <div class="tips">已使用</div>
                        </div>
                    </div>
                </Pull>
            </van-tab>
            <van-tab :title="`已过期（${summary.expirecount}）`">
                <Pull :pull="pull3" :page="page3" @getList="getMyCoupongetinfo">
                    <NoData v-if="!list3.length"></NoData>
                    <div class="list1 list2" v-else>
                        <div class="item" v-for="(item, index) in list3" :key="index">
                            <div class="left">
                                <div class="value_box" v-if="item.voucherdistype === 1">
                                    <span class="unit">￥</span>
                                    <span class="value">{{item.faceprice}}</span>
                                    <span class="minordermoney">
                                        <span v-if="item.userule === 0">满{{item.minordermoney}}元可用</span>
                                        <span v-if="item.userule === 1">无门槛</span>
                                    </span>
                                </div>
                                <div class="value_box" v-if="item.voucherdistype === 2">
                                    <span class="value">{{item.voucherdisrate}}</span>
                                    <span class="unit">折</span>
                                    <span class="minordermoney">
                                        <span v-if="item.userule === 0">满{{item.minordermoney}}元可用</span>
                                        <span v-if="item.userule === 1">无门槛</span>
                                    </span>
                                </div>
                                <div class="datetime">{{item.datetime}}</div>
                                <div class="usescopetype">{{item.usescopetype === 2 ? '指定商品可用' : '平台部分商品可用'}}</div>
                            </div>
                            <div class="right">
                                <!-- <van-button>立即使用</van-button> -->
                            </div>
                            <div class="tips">已过期</div>
                        </div>
                    </div>
                </Pull>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import Pull from 'views/mobile/components/pull/pull'
import NoData from 'views/mobile/components/noData/noData'
import {getMyCoupongetinfo} from 'api/api'
import {mapActions, mapGetters} from 'vuex'
export default {
    data() {
        return {
            active: 0,
            page1: {
                page: 1,
                pageSize: 10,
                pageCount: 0,
                rowCount: 0
            },
            pull1: {
                isLoading: false,
                loading: false,
                error: false,
                finished: false
            },
            page2: {
                page: 1,
                pageSize: 10,
                pageCount: 0,
                rowCount: 0
            },
            pull2: {
                isLoading: false,
                loading: false,
                error: false,
                finished: false
            },
            page3: {
                page: 1,
                pageSize: 10,
                pageCount: 0,
                rowCount: 0
            },
            pull3: {
                isLoading: false,
                loading: false,
                error: false,
                finished: false
            },
            list1: [],
            list2: [],
            list3: [],
            init: false,
            summary: {}
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        this.getMyCoupongetinfo()
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {
        document.title = '我的优惠券'
        this.setNoDataTip('当前暂无优惠券')
    },
    methods: {
        // 立即使用
        nowUse(item) {
            this.$router.push({
                name: 'MSearchList',
                query: {
                    couponinnerid: item.couponinnerid,
                    voucherdistype: item.voucherdistype
                }
            })
        },
        tabChange() {
            if (this.active === 0) {
                if (!this.list1.length) {
                    this.page1.page = 1
                    this.getMyCoupongetinfo()
                }
            } else if (this.active === 1) {
                if (!this.list2.length) {
                    this.page2.page = 1
                    this.getMyCoupongetinfo()
                }
            }  else if (this.active === 2) {
                if (!this.list3.length) {
                    this.page3.page = 1
                    this.getMyCoupongetinfo()
                }
            }
        },
        getMyCoupongetinfo() {
            const params = {
                pageSize: 10,
                page: '',
                status: ''
            }
            if (this.active === 0) {
                params.page = this.page1.page
                params.status = 0
                console.log(this.page1)
            } else if (this.active === 1) {
                params.page = this.page2.page
                params.status = 10
                console.log(this.page2)
            } else if (this.active === 2) {
                params.page = this.page3.page
                params.status = 100
                console.log(this.page3)
            }
            this.setLoading(true)
            getMyCoupongetinfo({
                data: params,
                success: res => {
                    if (this.active === 0) {
                        if (params.page === 1) {
                            this.pull1.isLoading = false
                            this.list1 = res.data.content
                            this.summary = res.data.summary
                        } else {
                            this.list1 = this.list1.concat(res.data.content)
                        }
                        this.pull1.loading = false
                        this.page1.pageCount = res.data.pageinfo.pageCount
                        this.page1.rowCount = res.data.pageinfo.rowCount
                        if (this.page1.page === this.page1.pageCount) {
                            this.pull1.finished = true
                        }
                    } else if (this.active === 1) {
                        if (params.page === 1) {
                            this.pull2.isLoading = false
                            this.list2 = res.data.content
                            this.summary = res.data.summary
                        } else {
                            this.list2 = this.list2.concat(res.data.content)
                        }
                        this.pull2.loading = false
                        this.page2.pageCount = res.data.pageinfo.pageCount
                        this.page2.rowCount = res.data.pageinfo.rowCount
                        if (this.page2.page === this.page2.pageCount) {
                            this.pull2.finished = true
                        }
                        console.log(this.page2, this.pull2)
                    } else if (this.active === 2) {
                        if (params.page === 1) {
                            this.pull3.isLoading = false
                            this.list3 = res.data.content
                            this.summary = res.data.summary
                        } else {
                            this.list3 = this.list3.concat(res.data.content)
                        }
                        this.pull3.loading = false
                        this.page3.pageCount = res.data.pageinfo.pageCount
                        this.page3.rowCount = res.data.pageinfo.rowCount
                        if (this.page3.page === this.page3.pageCount) {
                            this.pull3.finished = true
                        }
                    }
                    console.log(this.page3, this.pull3)
                    this.init = true
                    this.setLoading(false)
                    console.log(res)
                },
                error: res => {
                    this.setLoading(false)
                    this.$toast.fail(res.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setNoDataTip'
        ])
    },
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {
        Pull,
        NoData
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    // #app {
    //     height: 100%;
    // }
    // .MMy {
    //     min-height: 100vh;
    // }
    .MMyCoupon {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        .van-tabs {
            flex: 1;
            display: flex;
            flex-direction: column;
            .van-tabs__wrap {
                height: 0.8rem;
                height: 1rem;
                width: 100%;
                overflow: visible;
                position: fixed;
                top: 0;
                z-index: 1000;
                box-sizing: border-box;
                .van-tabs__nav {
                    padding: 0;
                }
                .van-tab {
                    font-size: 0.28rem;
                }
                .van-tab--active {
                    color: #409EFF;
                }
                .van-tabs__line {
                    height: 0.03rem;
                    background: #409EFF;
                    bottom: 0;
                }
            }
            .van-tabs__content {
                flex: 1;
                padding-top: 1rem;
                background: #F5F7FA;
                display: flex;
                flex-direction: column;
                .van-tab__pane {
                    flex: 1;
                    // display: flex;
                    // flex-direction: column;
                    // .pull {
                    //     flex: 1;
                    //     display: flex;
                    //     flex-direction: column;
                    //     .van-pull-refresh {
                    //         flex: 1;
                    //         display: flex;
                    //         flex-direction: column;
                    //         .van-pull-refresh__track {
                    //             flex: 1;
                    //             display: flex;
                    //             flex-direction: column;
                    //             .van-list {
                    //                 flex: 1;
                    //                 overflow: scroll;
                    //             }
                    //         }
                    //     }
                    // }
                    .list1 {
                        margin-top: 0.2rem;
                        padding: 0.2rem 0.32rem;
                        background: #fff;
                        .item {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 0.1rem 0.24rem 0.12rem;
                            background: #FEF6EF;
                            margin-bottom: 0.2rem;
                            border-radius: 0.1rem;
                            position: relative;
                            .left {
                                .value_box {
                                    color: #FE666D;
                                    .unit {
                                        font-size: 0.3rem;
                                    }
                                    .value {
                                        font-size: 0.52rem;
                                        line-height: 0.72rem;
                                    }
                                    .minordermoney {
                                        font-size: 0.28rem;
                                        margin-left: 0.1rem;
                                    }
                                }
                                .datetime {
                                    font-size: 0.2rem;
                                    color: #9DA4AF;
                                    margin-bottom: 0.1rem;
                                }
                                .usescopetype {
                                    font-size: 0.2rem;
                                    color: #9DA4AF;
                                }
                            }
                            .right {
                                .van-button {
                                    width: 1.6rem;
                                    height: 0.4rem;
                                    background: #FE666D;
                                    color: #fff;
                                    padding: 0;
                                    line-height: 0.4rem;
                                    border-radius: 0.3rem;
                                    font-size: 0.24rem;
                                }
                            }
                            .tips {
                                position: absolute;
                                top: 0;
                                right: 0;
                                width: 1.12rem;
                                height: 0.36rem;
                                background: #FEE4E5;
                                color: #FE666D;
                                border-radius: 0 0.1rem 0 0.1rem;
                                text-align: center;
                                line-height: 0.36rem;
                            }
                        }
                    }
                    .list2 {
                        .item{
                            background: #E5E5E5;
                            .left {
                                .value_box {
                                    color: #999999;
                                }
                            }
                            .tips {
                                color: #fff;
                                background: #999999;
                            }
                        }
                    }
                    .noData{
                        height: 100vh;
                        background: #fff;
                    }
                }
            }
        }
    }
</style>